import { ImageDto } from '@/lib/image.dto';

import { GalleryMatterport } from './GalleryMatterport';
import { GallerySummaryImage } from './GallerySummaryImage';

import clsx from 'clsx';

type GallerySummaryProps = {
  images: ImageDto[];
  primaryImgSizes: string;
  otherImgSizes: string;
  numberImagesToDisplay?: number;
  matterportUrl?: string | null;
  showMatterportThumbnail?: boolean;
};

export function GallerySummaryImages({
  images,
  numberImagesToDisplay = 3,
  primaryImgSizes,
  otherImgSizes,
  matterportUrl,
  showMatterportThumbnail,
}: GallerySummaryProps) {
  const imagesToDisplay =
    showMatterportThumbnail && matterportUrl
      ? images.slice(1, numberImagesToDisplay - 1)
      : images.slice(1, numberImagesToDisplay);

  return (
    <>
      <GallerySummaryImage
        className="flex-1 object-cover object-center h-full rounded"
        image={images[0]}
        sizes={primaryImgSizes}
        priority
      />
      <div
        className={clsx(
          'hidden grid-rows-2 gap-5 lg:grid',
          numberImagesToDisplay > 3 ? 'grid-cols-2' : 'w-[388px]'
        )}
      >
        {imagesToDisplay.map((image) => (
          <div className="w-full overflow-auto" key={image.url}>
            <GallerySummaryImage
              className="object-cover object-center h-full overflow-auto rounded"
              image={image}
              sizes={otherImgSizes}
              loading="lazy"
            />
          </div>
        ))}
        {showMatterportThumbnail && matterportUrl && (
          <div>
            <GalleryMatterport
              className="w-full h-full rounded"
              url={matterportUrl}
            />
          </div>
        )}
      </div>
    </>
  );
}
